import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_9 = ({ skinColours, lipColours }) => {
  const colour0 = lipColours.base;
  const colour1 = lipColours.base;
  const colour2 = lipColours.shadow;
  const colour3 = '#40332E';
  const colour4 = '#3B2E2A';
  const colour5 = '#342723';
  const colour6 = '#231A18';
  const colour7 = '#FFFEF0';
  const colour8 = '#FFE9CF';
  const colour9 = '#EC4845';
  const colour10 = '#F26767';
  const colour11 = '#F37D79';
  const colour12 = '#F58E87';
  const colour13 = lipColours.base;
  const colour14 = '#F2D5B2';
  const colour15 = '#F8B2B3';

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M479.6,651.2c-0.2-2.5-158.8-10.6-158.5,6.4c0.3,17.8,21.7,55.8,30.6,66.8c13.4,16.6,74.6,17.6,91.7,1.6
		C471.1,699.8,480.1,658.6,479.6,651.2z"
        />
        <path
          fill={colour1}
          d="M320.6,656.9c0.3-12,6.7-106.4,28.4-120.2c21.7-13.8,37.1,6,48.5,4c11.4-2.1,33.7-11.6,44-6.8
		c22.6,10.5,38.2,110.7,38.6,115.1c0.4,4.1-10.2,45.4-38,71.6c-17,16.1-75.4,15.9-88.8-0.8C344.4,708.8,320.3,666.5,320.6,656.9z"
        />
        <path
          fill={colour2}
          d="M480.1,649c-0.2-2.5-5.6-37.4-14.5-68.3c-6.9,3.6-52.4-25-57-42.9c-4.2,1.2-8.1,2.3-11.1,2.9
		c-3.9,0.7-8.3-1.2-13.3-3.4c-1.7,16.3-35.7,46-55.2,47.9c-6,30.5-8.2,64.8-8.4,71.7c-0.3,9.5,22.2,53.5,31.1,64.5
		c13.4,16.6,74.6,17.7,91.7,1.6C471.1,696.7,480.5,653.1,480.1,649z M450.5,709.1c-6.9,9.2-27.6,22-51.6,22
		c-32,0-48.1-12.3-52.9-22.8c-28.8-63.1,27.3-45.6,51.3-45.6C421.3,662.8,500.2,642.9,450.5,709.1z"
        />
        <path
          fill={colour0}
          d="M323.2,654.5c-0.4,3.5,25.5,48.1,76.7,46.5c56.5-1.8,75.8-51.3,75.8-51.3c-11.5-69-42-91.2-75-91.4
		C353.7,558.1,328.4,604.1,323.2,654.5z"
        />
        <path
          fill={colour3}
          d="M323.5,653.2c-0.4,3.3,26.4,46.9,76.3,45.4c55.1-1.7,75.4-50.1,75.4-50.1c-11.2-66.3-44.3-86.7-74.7-87
		C354.7,561,328.6,604.7,323.5,653.2z"
        />
        <path
          fill={colour4}
          d="M334.9,654.9c-0.3,2.9,22.5,40.1,64.8,38.8c46.8-1.5,64-42.9,64-42.9c-9.5-57.7-37.6-74.1-63.5-74.4
		C361.4,576.1,339.2,612.7,334.9,654.9z"
        />
        <path
          fill={colour5}
          d="M348.8,658.3c-0.2,2.2,17.2,30.5,49.8,29.5c35.9-1.1,49.2-32.6,49.2-32.6c-7.3-43.9-28.9-56.4-48.7-56.6
		C369.2,598.3,352.1,626.2,348.8,658.3z"
        />
        <path
          fill={colour6}
          d="M363,660.2c-0.2,1.6,12.3,21.8,35.5,21c25.6-0.8,35-23.3,35-23.3c-5.2-31.3-20.6-40.2-34.7-40.3
		C377.5,617.5,365.4,637.4,363,660.2z"
        />
        <path
          fill={colour5}
          d="M389.8,617.9c12.7-2.2-1.2,20.1,8.3,20.8c13.6,0.9-4.6-24.8,11.9-19.3c0,0-4.5-6.2-13.2-6.8
		C388.2,612.1,389.8,617.9,389.8,617.9z"
        />
        <path
          fill={colour7}
          d="M346.4,605.3c-2.2,0.1-2.7-5.6,1-11.5c3.6-5.9,22.9-27.9,51.3-27.9c28.4-0.1,47.8,15.8,56.4,30.7
		c2.2,3.8,1.8,8.6-0.1,9.1c-1.9,0.4-17.7-15.4-54.8-15.5C366.1,590,348.6,605.2,346.4,605.3z"
        />
        <path
          fill={colour8}
          d="M455,603c-1.9,0.4-18.4-14.9-55.5-15c-34.2-0.1-51,14.6-53.2,14.7c-0.8,0-1.4-0.7-1.6-2
		c-0.4,2.8,0.3,4.7,1.6,4.6c2.2-0.1,19.3-14.5,53.5-14.5c37,0.1,53.2,15.3,55.1,14.8c1.2-0.3,1.8-2.4,1.5-4.9
		C456.3,602,455.8,602.8,455,603z"
        />
        <path
          fill={colour9}
          d="M409.4,647.2l42.1,17.5l11.7-6.5C456,643.4,428.4,643,409.4,647.2z"
        />
        <path
          fill={colour9}
          d="M383.9,647.2l-36.7,19.4l-11.7-6.5C342.7,645.3,364.9,643,383.9,647.2z"
        />
        <path
          fill={colour10}
          d="M337.7,662.6c7.6-6.3,21.4-23.8,57.9-12.2c0,0,47.9-15.6,65.2,11.2C464.2,669,388.5,716.9,337.7,662.6z"
        />
        <path
          fill={colour11}
          d="M341.6,663.7c7.1-5.9,19.8-24.2,54-13.3c0,0,45.1-12.8,61.3,12.3C460.1,669.7,389.2,714.6,341.6,663.7z"
        />
        <path
          fill={colour12}
          d="M396.5,653.1c-1-4.3-15.7-8.1-29.4-5.7c-13.7,2.4-24.9,10.3-24.2,14.6c0.8,4.3,16.7,8.5,30.5,6.1
		C387.2,665.7,398.5,662.1,396.5,653.1z"
        />
        <path
          fill={colour12}
          d="M397.8,657.3c4.3-8.7,14.8-11.4,28.6-10.6c13.9,0.8,28.4,7.4,28.1,11.8c-0.3,4.4-21.6,12.4-35.4,11.6
		C405.3,669.3,393.7,665.6,397.8,657.3z"
        />
        <g>
          <path
            fill={colour10}
            d="M396.1,657.7c1.4-4.4,5-7.6,9.9-9.9c-6.3,1.2-10.4,2.6-10.4,2.6c-0.9-0.3-1.7-0.5-2.6-0.8
			C395.2,651.2,396.1,653.6,396.1,657.7z"
          />
          <path
            fill={colour10}
            d="M460.7,661.6c-1.7-2.7-3.8-4.9-6-6.8c-4.9,6-68,28.2-111.4,2.9c-2.2,1.9-4.1,3.7-5.6,5
			C388.5,716.9,464.2,669,460.7,661.6z"
          />
        </g>
        <path
          fill={colour7}
          d="M333,663.9c0,0,1-4.6,4.2-3.9c3.3,0.7,28.4,13,55.9,13.3c42.4,0.5,68.1-17.9,70.6-15.7
		c2.5,2.2,1.4,4.4,1.4,4.4s-24.4,38.5-73.1,34.3C350.3,692.7,333,663.9,333,663.9z"
        />
        <path
          fill={colour13}
          d="M405.7,727.1c11.5-2.6,22.1-12.9,16.2-15.6c-17.7-8-79.1-8.5-65.2,3.3C370.2,726.2,399.3,728.6,405.7,727.1z"
        />
        <path
          fill={colour4}
          d="M392.3,592.8c-0.2-0.1-0.3-0.2-0.3-0.4s0.1-0.3,0.3-0.4c2.5-0.9,3.9-3.9,3.9-8.4c0,0,0.4,5.7,2.6,7.6
		c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.2,0.5-0.4,0.6c-0.8,0.4-1.9,0.9-3.1,0.8C394.4,593.4,393.2,593.1,392.3,592.8z"
        />
        <path
          fill={colour4}
          d="M425.3,594.5c-0.1-0.1-0.2-0.2-0.2-0.2c0-0.1,0.1-0.1,0.3-0.1c2.1,0.1,3.5-1.1,4.1-3.3c0,0-0.4,2.9,1.1,4.3
		c0.1,0.1,0.2,0.3,0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.7,0-1.6,0-2.5-0.3C426.8,595.2,425.9,594.8,425.3,594.5z"
        />
        <path
          fill={colour14}
          d="M347.1,598.1c3.6-5.9,22.8-25.2,51.2-25.2c28.4-0.1,48.5,13.4,57.1,28.4c0.5,0.8,0.8,1.7,1,2.5
		c0.6-2.1,0.5-5.5-1-8c-8.6-14.9-28.7-32-57.1-32c-28.4,0.1-47.6,22.9-51.2,28.8c-2.5,4.1-2.9,8.7-2.2,11.1
		C345.3,601.9,346,599.9,347.1,598.1z"
        />
        <path
          fill={colour7}
          d="M333,663.9c0,0,1-4.6,4.2-3.9c3.3,0.7,28.4,13,55.9,13.3c42.4,0.5,68.1-17.9,70.6-15.7
		c2.5,2.2,1.4,4.4,1.4,4.4s-24.4,36.7-73.1,32.5C350.3,690.9,333,663.9,333,663.9z"
        />
        <path
          fill={colour8}
          d="M337.5,661.6c3.3,0.7,28.4,13,55.9,13.3c42.4,0.5,68.1-17.9,70.6-15.7c0.6,0.6,1,1.1,1.3,1.6
		c0.2-0.7,0.3-2.4-1.6-4c-2.5-2.2-28.2,16.2-70.6,15.7c-27.4-0.3-52.6-12.6-55.9-13.3c-3.3-0.7-4.2,3.9-4.2,3.9s0.2,0.4,0.7,1
		C334.2,662.9,335.4,661.1,337.5,661.6z"
        />
        <path
          fill={colour14}
          d="M463.7,657.6c-0.1-0.1-0.4-0.2-0.7-0.2c2,7.7-22,35.8-68.1,35.8c-34.2,0-60.6-26-59.3-33.1
		c-2,0.8-2.6,3.8-2.6,3.8s17.3,28.8,59,32.4c48.7,4.2,73.1-34.3,73.1-34.3S466.2,659.8,463.7,657.6z"
        />
        <path
          fill={colour13}
          d="M358.4,533.5c-14.6,2.8-18.7,20.4-18.1,24.2c0.7,3.9,30.6-9.5,34.7-17C378,535.3,367.2,531.8,358.4,533.5z"
        />
        <path
          fill={colour13}
          d="M438.2,533.9c-8.5-1.4-21.5,1.5-16.5,9.3c5,7.7,28.7,19.7,30,15.7C454.6,550.5,446,535.1,438.2,533.9z"
        />
        <path
          fill={colour13}
          d="M418.2,540.9c-1.4,1.4-5.5-0.5-4.9-2.3c0.5-1.8,5-1.9,5.7-1.5C419.7,537.5,418.8,540.4,418.2,540.9z"
        />
        <path
          fill={colour13}
          d="M380.4,540.4c-1.7,0.2-4.9-3.8-4.1-4.5c0.8-0.7,4.8,0.9,5.3,1.7C382.1,538.4,381.2,540.3,380.4,540.4z"
        />
        <g>
          <path
            fill={colour0}
            d="M412.7,560.3c-6.4-2.9-8.7-7.4-9.3-8.8c1.1,3.3,0.2,8.1,0.2,8.1L412.7,560.3z"
          />
        </g>
        <polygon
          fill={colour14}
          points="396.8,695.2 397.1,685.8 399.4,695.2 	"
        />
        <path
          fill={colour15}
          d="M425.1,647.9c0-0.5-1-0.9-2.2-0.9s-2.2,0.4-2.2,0.9c0,0.5,1,0.9,2.2,0.9S425.1,648.4,425.1,647.9z"
        />
        <path
          fill={colour15}
          d="M431.4,649.4c0-0.4-0.6-0.6-1.4-0.6c-0.8,0-1.4,0.3-1.4,0.6c0,0.4,0.6,0.6,1.4,0.6
		C430.7,650,431.4,649.7,431.4,649.4z"
        />
        <path
          fill={colour15}
          d="M417,650.5c0-0.4-0.6-0.6-1.4-0.6c-0.8,0-1.4,0.3-1.4,0.6c0,0.4,0.6,0.6,1.4,0.6
		C416.4,651.2,417,650.9,417,650.5z"
        />
        <path
          fill={colour10}
          d="M450,655.9c0-0.4-0.9-0.8-2-0.8c-1.1,0-2,0.4-2,0.8c0,0.4,0.9,0.8,2,0.8C449.1,656.7,450,656.4,450,655.9z"
        />
        <path
          fill={colour10}
          d="M435.3,660.3c0-0.4-0.9-0.8-2-0.8c-1.1,0-2,0.4-2,0.8c0,0.4,0.9,0.8,2,0.8
		C434.4,661.1,435.3,660.8,435.3,660.3z"
        />
        <path
          fill={colour10}
          d="M440.3,655.1c0-0.3-0.5-0.6-1.2-0.6c-0.6,0-1.2,0.3-1.2,0.6c0,0.3,0.5,0.6,1.2,0.6
		C439.7,655.7,440.3,655.4,440.3,655.1z"
        />
        <path
          fill={colour11}
          d="M413.1,665.4c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C412.4,666.2,413.1,665.8,413.1,665.4z"
        />
        <path
          fill={colour11}
          d="M408.5,652.3c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C407.8,653.1,408.5,652.7,408.5,652.3z"
        />
        <path
          fill={colour11}
          d="M444,658.4c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C443.3,659.2,444,658.8,444,658.4z"
        />
        <path
          fill={colour10}
          d="M391.5,652.8c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C390.8,653.6,391.5,653.3,391.5,652.8z"
        />
        <path
          fill={colour15}
          d="M379.3,649.1c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C378.6,649.9,379.3,649.5,379.3,649.1z"
        />
        <path
          fill={colour15}
          d="M366,651.1c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C365.2,651.9,366,651.5,366,651.1z"
        />
        <path
          fill={colour15}
          d="M374.3,653c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C373.6,653.8,374.3,653.4,374.3,653z"
        />
        <path
          fill={colour11}
          d="M377.1,665.4c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C376.4,666.2,377.1,665.8,377.1,665.4z"
        />
        <path
          fill={colour10}
          d="M351.9,658c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C351.1,658.8,351.9,658.5,351.9,658z"
        />
        <path
          fill={colour10}
          d="M392.7,659.3c0-0.4-0.7-0.8-1.6-0.8c-0.9,0-1.6,0.4-1.6,0.8c0,0.4,0.7,0.8,1.6,0.8
		C392,660.1,392.7,659.7,392.7,659.3z"
        />
        <path
          fill={colour13}
          d="M437.5,716.8c-2,2.9-9.5,5-11.5,4.8c-1.9-0.2,0.5-6.8,2.7-8.1C430.9,712.1,442.1,710.3,437.5,716.8z"
        />
        <polygon fill={colour0} points="398,700 399.6,707.5 400.5,700.1 	" />
        <polygon fill={colour0} points="422,696.5 425.2,701.2 424.2,695.9 	" />
        <polygon fill={colour2} points="389.5,731.6 388.8,724 387.2,731.2 	" />
        <polygon fill={colour2} points="358.8,722.8 358.9,717.6 356.9,722.1 	" />
        <polygon fill={colour2} points="428,726.2 424.9,722.1 426.1,726.9 	" />
        <polygon fill={colour2} points="450.3,712.2 447.8,705.5 448.4,712.7 	" />
        <polygon
          fill={colour14}
          points="396.1,569.1 397.2,576.7 397.9,569.4 	"
        />
        <polygon fill={colour14} points="370,576.1 371,583.7 371.8,576.3 	" />
      </g>
    </>
  );
};

export default Mouth_9;
